import * as React from 'react'

export type DiffEntry = {
  key: string
  label: string
  before: unknown
  after: unknown
  /** Simple string formatter applied to each side independently. */
  format?: (value: unknown) => string
  /** Custom renderer — receives both sides, returns separate before/after cell content. */
  renderDiff?: (before: unknown, after: unknown) => { before: React.ReactNode; after: React.ReactNode }
}

export function computeDiff(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
  labels?: Record<string, string>,
  formatters?: Record<string, (value: unknown) => string>,
  renderers?: Record<string, (before: unknown, after: unknown) => { before: React.ReactNode; after: React.ReactNode }>,
): DiffEntry[] {
  const allKeys = [...new Set([...Object.keys(before ?? {}), ...Object.keys(after ?? {})])]
  return allKeys
    .filter((key) => JSON.stringify(before?.[key]) !== JSON.stringify(after?.[key]))
    .map((key) => ({
      key,
      label: labels?.[key] ?? camelToLabel(key),
      before: before?.[key],
      after: after?.[key],
      format: formatters?.[key],
      renderDiff: renderers?.[key],
    }))
}

export function formatDiffValue(value: unknown, format?: (value: unknown) => string): string {
  if (format) return format(value)
  if (value === null || value === undefined) return '—'
  if (typeof value === 'boolean') return value ? 'Włączone' : 'Wyłączone'
  if (typeof value === 'number') return String(value)
  if (typeof value === 'string') return value.length > 60 ? `${value.slice(0, 57)}…` : value || '—'
  if (Array.isArray(value)) return `(${value.length} elementów)`
  if (typeof value === 'object') return JSON.stringify(value).slice(0, 60)
  return String(value)
}

function camelToLabel(key: string): string {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (s) => s.toUpperCase())
    .trim()
}
